// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
'use strict';
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class OrderIdGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.ORDER_ID_GROUP, null, pfixFieldSet);
    }
    setOrderId(orderId) {
        this.SetField(FieldsFactory.FIELD_ORDER_ID, orderId);
    }
}
